// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/common.css'
import 'font-awesome/css/font-awesome.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'

import VueDraggable from 'vuedraggable'

export default new Vue()

Vue.use(VueDraggable)

Vue.use(VueAwesomeSwiper /* { default global options } */)

Vue.config.productionTip = false

Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    console.log('重定向了啊')
    // 当访问根路径时，重定向到 /ColEditWindow
    return router.push('/ColEditWindow')
  }
  next()
})

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   render: h => h(App),
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  router, // 使用路由
  render: h => h(App) // 使用 App 作为根组件
}).$mount('#app') // 挂载到 #app 元素



// WEBPACK FOOTER //
// ./src/main.js